import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { TenantsPage } from './pages/TenantsPage';
import { DashboardPage } from './pages/DashboardPage';
import { CustomersPage } from './pages/CustomersPage';
import { MetersPage } from './pages/MetersPage';
import { PlansPage } from './pages/PlansPage';
import { ContractsPage } from './pages/ContractsPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { InvoicePage } from './pages/InvoicePage';
import { UsagePage } from './pages/UsagePage';
import { SettingsPage } from './pages/SettingsPage';

export const router = createBrowserRouter([
  { path: '/', element: <TenantsPage /> },
  {
    path: '/t/:tenantId',
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'meters', element: <MetersPage /> },
      { path: 'plans', element: <PlansPage /> },
      { path: 'contracts', element: <ContractsPage /> },
      // Старый адрес раздела: ссылки из писем и закладок не должны ломаться.
      { path: 'subscriptions', element: <Navigate to="../contracts" replace /> },
      { path: 'invoices', element: <InvoicesPage /> },
      { path: 'invoices/:invoiceId', element: <InvoicePage /> },
      { path: 'usage', element: <UsagePage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  // Ссылка на счёт из письма приходит без тенанта — отправляем на выбор, а не показываем 404.
  { path: '/invoices/:invoiceId', element: <Navigate to="/" replace /> },
  { path: '*', element: <Navigate to="/" replace /> },
]);
